import ApiService from "./api.service";

class AttachmentsService extends ApiService {
    addFile(id, data) {
        return this.post(`api/meeting/agenda-items/${id}/attachments/files`, data, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        });
    }

    addFiles(id, data) {
        return this.post(`api/meeting/agenda-items/${id}/attachments/files`, data, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        });
    }

    addNote(id, data) {
        return this.post(`api/meeting/agenda-items/${id}/attachments/notes`, data);
    }

    addLink(id, data) {
        return this.post(`api/meeting/agenda-items/${id}/attachments/links`, data);
    }

    getNote(id, pid) {
        return this.get(`api/meeting/attachments/${pid}/notes/${id}`);
    }

    downloadAttachment(pid, id) {
        return this.get(`api/meeting/attachments/${pid}/files/${id}/download`, { responseType: "arraybuffer" });
    }

    updateFile(id, pid, data) {
        return this.post(`api/meeting/attachments/${pid}/files/${id}`, data);
    }

    updateNote(id, pid, data) {
        return this.post(`api/meeting/attachments/${pid}/notes/${id}`, data);
    }

    deleteFile(id, pid) { 
        return this.delete(`api/meeting/attachments/${pid}/files/${id}`);
    }

    deleteNote(id, pid) {
        return this.delete(`api/meeting/attachments/${pid}/notes/${id}`);
    }

    deleteAnnouncementFile(id, elemid) {
        return this.delete(`api/management/announcement/${elemid}/attachement/${id}`);
    }

    updateAnnouncementFile(id, elemid, data) {
        return this.post(`api/management/announcement/${elemid}/attachement/${id}`, data);
    }

    addAttachementToAnnouncement(id, data) {
        return this.post(`api/management/announcement/${id}/attachement`, data, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        });
    }

    downloadAnnouncementAttachment(elemId, id) {
        return this.get(`api/management/announcement/${elemId}/attachement/${id}/download`, { responseType: "arraybuffer" });
    }

    addOrUpdateStatement(pointId, data) {
        return this.post(`api/meeting/agenda-items/${pointId}/statements`, data);
    }

    deleteStatementFromAgenda(pointId, id) {
        return this.delete(`api/meeting/agenda-items/${pointId}/statements/${id}`)
    }
}

export default new AttachmentsService();
